var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.editorComponent,_vm._g(_vm._b({ref:"editor",tag:"component",class:['eum-editor-proxy' ].concat( _vm.classNames)},'component',Object.assign({}, _vm.$attrs, {type: _vm.type, mode: _vm.mode}),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }